WiseMetering.Views.CreateOrganization = WiseMetering.Views.Crud.Save.extend({
    template: 'templates/ui/crud/create',
    className: 'crud-info',
    object: 'organization',
    title: () => i18next.t('modal.title.organizations.new'),

    events: {
        'change select#country_code': 'changeCountry',
        'change select#type': 'changeType',
        'change .input-file': 'changeLogo',
        'click .btn-plans': 'changePlan',
        'keyup #name': 'changeName'
    },

    ui: {
        logoPreviewImage: '.preview-image',
        PreviewImageSection: '.preview-image-wrapper',
        subdomain: '#subdomain',
        plansSection: '#plan',
        plans: '.btn-plans',
        timezones: '#timezone'
    },

    afterSave: function() {
        WiseMetering.currentUser.get('organizations').push({
            disabled: false,
            id: this.model.id,
            name: this.model.get('name'),
            subdomain: this.model.get('subdomain')
        });

        WiseMetering.Views.Layouts.Root.prototype.navigateToOrganization(this.model.attributes);
    },

    changeCountry: function(event) {
        const timezones = WiseMetering.timezones[event.target.value];
        this.ui.timezones.html(timezones.map(tz => `<option value='${tz}'>${tz}</option>`));
    },

    changeLogo: function(event) {
        const [file] = event.target.files;
        if (file) {
            this.ui.PreviewImageSection.show();
            this.ui.logoPreviewImage.attr('src', URL.createObjectURL(file));
            this.logoFile = file;
        }
    },

    changeName: function(event) {
        const name = event.currentTarget.value,
            subdomain = WiseMetering.utils.toSnakeCase(name);

        this.ui.subdomain.val(subdomain);
    },

    changePlan: function(event) {
        event.preventDefault();

        this.deselectAllPlans();
        const planId = event.currentTarget.value;
        this.selectedPlan = WiseMetering.plans.get(planId);
        this.$(`.btn-${this.selectedPlan.get('name')}`).addClass('selected');
    },

    changeType: function(event) {
        event.preventDefault();

        this.ui.plansSection.empty();
        this.selectedPlan = '';
        WiseMetering.utils.addLoader('#plan', top = 0, bottom = 0, width = '60');
        setTimeout(() => {
            this.ui.plansSection.empty();
            this.ui.plansSection.append(JST['templates/plans/plans']({ object: 'organization', plans: this.getPlans() }));
        }, 500);
    },

    deselectAllPlans: function() {
        WiseMetering.plans.forEach(plan => {
            this.$(`.btn-${plan.get('name')}`).removeClass('selected');
        });
    },

    fields: function() {
        return {
            object: 'organization',
            list: [
                { name: 'name', label: i18next.t('common.name'), value: this.model.get('name'), type: 'text' },
                { name: 'subdomain', label: i18next.t('glossary.subdomain'), value: this.model.get('subdomain'), type: 'text' },
                { name: 'country_code', label: i18next.t('common.country'), options: WiseMetering.countries.toJSON(), slug: 'country_code', type: 'select' },
                { name: 'timezone', label: i18next.t('glossary.timezone'), options: [], type: 'select' },
                { name: 'currency', label: i18next.t('common.currency'), options: WiseMetering.currencies, type: 'select' },
                { name: 'type', label: i18next.t('common.type'), options: WiseMetering.organizationTypes, slug: 'slug', type: 'select' },
                { name: 'plan', field: 'plan_id', label: i18next.t('glossary.plans'), options: WiseMetering.plans.toJSON(), type: 'custom' },
                { name: 'logo', label: i18next.t('organizations.logo_label'), type: 'file', preview: true }
            ]
        };
    },

    getFormData: function() {
        const data = this.formSerializer();

        if (this.logoFile) {
            data.logo = this.logoFile;
        }

        data.plan_id = this.selectedPlan ? this.selectedPlan.id : '';

        return data;
    },

    getPlans: function() {
        const type = this.getFormData().type;
        if (!type) {
            return;
        }

        if (type === 'site') {
            return WiseMetering.plans.toJSON();
        } else {
            return WiseMetering.plans.toJSON().filter(plan => plan.name !== 'essentials');
        }
    },

    onShow: function() {
        this.logoFile = null;
        this.ui.PreviewImageSection.hide();
        this.ui.plansSection.append(JST['templates/plans/plans']({ object: 'organization', plans: this.getPlans() }));
    },

    serializeData: function() {
        let json = this.model.toJSON();
        json.fields = this.fields();
        return json;
    },

    submitData: function(data) {
        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }

        // https://stopbyte.com/t/how-to-send-multipart-formdata-with-jquery-and-ajax/58/2
        return $.ajax({
            contentType: false,
            data: formData,
            processData: false,
            type: 'POST',
            url: '/organizations',
            success: function(data) {
                this.model.set(data);
            }.bind(this)
        });
    }
});
